module.exports = __webpack_public_path__ + "img/image_second_left.9d2da691.png";